import React, { Component } from 'react';
import {
  Container, Row, Col, Button, Modal, ModalBody, ModalHeader, ModalFooter,
} from 'reactstrap';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import CreatePetForm from '../../forms/Pet';
import { getPetData, editPetData, deletePet } from '../../services/Pets/actions';
import { CustomLoading } from '../../components/Loading';

const Title = styled.h1`
  text-align: center;
`;

class PetDetails extends Component {
  state = {
    deletePetModal: false,
  }

  constructor(props) {
    super(props);
    this.toggleDeletePetModal = this.toggleDeletePetModal.bind(this);
  }

  componentDidMount() {
    this.props.getPetData(this.props.match.params.id);
  }

  handlePetEdit = (values) => {
    this.props.editPetData(this.props.match.params.id, values, () => {
      this.props.history.push(`/client/${this.props.Pets.petData.owner}`);
    });
  }

  toggleDeletePetModal() {
    this.setState(prevState => ({
      deletePetModal: !prevState.deletePetModal,
    }));
  }


  render() {
    const {
      Pets: {
        isLoading,
        petData,
      },
    } = this.props;

    if (isLoading) {
      return (
        <CustomLoading />
      );
    }
    return (
      <Container>
        <Row>
          <Col md={{ size: 8, offset: 2 }}>
            <div className="d-flex flex-column justify-content-center align-items mt-3">
              <Title>
                Edit Pet
              </Title>
            </div>
            <div className="d-flex justify-content-end">
              <Button onClick={this.toggleDeletePetModal} className="mt-2 mr-2 mb-2" color="danger">
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            </div>
            <CreatePetForm
              isLoading={isLoading}
              onSubmit={this.handlePetEdit}
              initialValues={petData}
              isNew={false}
            />
          </Col>
        </Row>
        <Modal isOpen={this.state.deletePetModal} toggle={this.toggleDeletePetModal}>
          <ModalHeader toggle={this.toggleDeletePetModal}>
            Delete Pet?
          </ModalHeader>
          <ModalBody>
            <div>
              Delete this pet?
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() => {
                this.props.deletePet(this.props.match.params.id, () => {
                  this.props.history.push(`/client/${petData.owner}`);
                });
              }}
            >
              Yes
            </Button>
            <Button color="secondary" onClick={() => { this.toggleDeletePetModal(); }}>No</Button>
          </ModalFooter>
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  Pets: state.Pets,
});

const mapDispatchToProps = {
  editPetData,
  deletePet,
  getPetData,
};

export default connect(mapStateToProps, mapDispatchToProps)(PetDetails);
